import { Checkbox, Col, Divider, Drawer, Row, Typography } from "antd";
import axios from "axios";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../context";

const MerchantConfig = ({ open, close, getMerchantList, selectedData }) => {
  const { rerunNotif } = useContext(NotificationInfo);

  const [allowAge, setAllowAge] = useState(false);
  const [allowGender, setAllowGender] = useState(false);
  const [allowGcash, setAllowGcash] = useState(false);

  const [allowDine, setAllowDine] = useState(false);
  const [allowTakeout, setAllowTakeout] = useState(false);
  const [allowPickup, setAllowPickup] = useState(false);
  const [allowDelivery, setAllowDelivery] = useState(false);

  const [allowBanner, setAllowBanner] = useState(false);
  const [allowDineSetup, setAllowDineSetup] = useState(false);
  const [allowAdditionalServices, setAllowAdditionalServices] = useState(false);
  const [allowDinePayLater, setAllowDinePayLater] = useState(false);
  const [allowSubCategory, setAllowSubCategory] = useState(false);

  const [allowVariant, setAllowVariant] = useState(false);
  const [allowPerKilo, setAllowPerKilo] = useState(false);
  const [allowHouseKeeping, setAllowHouseKeeping] = useState(false);

  const [allowPunchingTransaction, setAllowPunchingTransaction] =
    useState(false);
  const [allowStoreAttendance, setAllowStoreAttendance] = useState(false);
  const [allowMultipleCashier, setAllowMultipleCashier] = useState(false);

  const [disable, setDisable] = useState(false);

  const onChange = (e, permission) => {
    const formdata = new FormData();
    formdata.append("user_id", selectedData.user_id);
    formdata.append("method", e.target.checked ? "create" : "delete");
    formdata.append("permission", permission);

    setDisable(true);
    axios
      .post("user/merchant/update-or-create/permission", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif(
            "success",
            e.target.checked
              ? "Created permission successfully."
              : "Deleted permission successfully."
          );
          setTimeout(() => {
            setDisable(false);
            getEmployeePermission();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("ERROR: ", error);
        setDisable(false);
      });
  };

  const getEmployeePermission = useCallback(() => {
    var params = { user_id: selectedData.user_id };
    axios
      .get("user/merchant/get/spec-employee-permission", { params })
      .then((response) => {
        const data = response.data;
        setAllowAge(
          data.find(({ permission }) => permission === "allow-age")
            ? true
            : false
        );
        setAllowGender(
          data.find(({ permission }) => permission === "allow-gender")
            ? true
            : false
        );
        setAllowGcash(
          data.find(({ permission }) => permission === "allow-gcash")
            ? true
            : false
        );
        setAllowDine(
          data.find(({ permission }) => permission === "allow-dine")
            ? true
            : false
        );
        setAllowTakeout(
          data.find(({ permission }) => permission === "allow-takeout")
            ? true
            : false
        );
        setAllowPickup(
          data.find(({ permission }) => permission === "allow-pickup")
            ? true
            : false
        );
        setAllowDelivery(
          data.find(({ permission }) => permission === "allow-delivery")
            ? true
            : false
        );
        setAllowBanner(
          data.find(({ permission }) => permission === "allow-banner")
            ? true
            : false
        );
        setAllowDineSetup(
          data.find(({ permission }) => permission === "allow-dine-setup")
            ? true
            : false
        );
        setAllowAdditionalServices(
          data.find(
            ({ permission }) => permission === "allow-additional-services"
          )
            ? true
            : false
        );
        setAllowDinePayLater(
          data.find(({ permission }) => permission === "allow-dine-paylater")
            ? true
            : false
        );
        setAllowSubCategory(
          data.find(({ permission }) => permission === "allow-sub-category")
            ? true
            : false
        );
        setAllowVariant(
          data.find(({ permission }) => permission === "allow-product-variant")
            ? true
            : false
        );
        setAllowPerKilo(
          data.find(({ permission }) => permission === "allow-product-per-kilo")
            ? true
            : false
        );
        setAllowHouseKeeping(
          data.find(({ permission }) => permission === "allow-house-keeping")
            ? true
            : false
        );
        setAllowPunchingTransaction(
          data.find(
            ({ permission }) => permission === "allow-punching-transaction"
          )
            ? true
            : false
        );
        setAllowStoreAttendance(
          data.find(({ permission }) => permission === "allow-store-attendance")
            ? true
            : false
        );
        setAllowMultipleCashier(
          data.find(({ permission }) => permission === "allow-multiple-cashier")
            ? true
            : false
        );
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [selectedData.user_id]);

  useEffect(() => {
    getEmployeePermission();
  }, [getEmployeePermission]);

  return (
    <Drawer
      title="Set Config"
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
      // width={400}
      width={window.innerWidth > 400 ? 400 : "100vw"}
    >
      <Row>
        <Col span={24} style={{ marginBottom: 10 }}>
          <Typography style={{ fontSize: 20, fontWeight: "bold" }}>
            Customer Inputs
          </Typography>
        </Col>
        <Col span={24}>
          <Checkbox
            onChange={(e) => onChange(e, "allow-age")}
            checked={allowAge}
            disabled={disable}
          >
            Allow Age
          </Checkbox>
        </Col>
        <Col span={24}>
          <Checkbox
            onChange={(e) => onChange(e, "allow-gender")}
            checked={allowGender}
            disabled={disable}
          >
            Allow Gender
          </Checkbox>
        </Col>
        <Col span={24}>
          <Checkbox
            onChange={(e) => onChange(e, "allow-gcash")}
            checked={allowGcash}
            disabled={disable}
          >
            Allow Payment Gcash
          </Checkbox>
        </Col>
        <Col span={24}>
          <Checkbox
            onChange={(e) => onChange(e, "allow-dine")}
            checked={allowDine}
            disabled={disable}
          >
            Allow Dine
          </Checkbox>
        </Col>
        <Col span={24}>
          <Checkbox
            onChange={(e) => onChange(e, "allow-takeout")}
            checked={allowTakeout}
            disabled={disable}
          >
            Allow Takeout
          </Checkbox>
        </Col>
        <Col span={24}>
          <Checkbox
            onChange={(e) => onChange(e, "allow-pickup")}
            checked={allowPickup}
            disabled={disable}
          >
            Allow Pickup
          </Checkbox>
        </Col>
        <Col span={24}>
          <Checkbox
            onChange={(e) => onChange(e, "allow-delivery")}
            checked={allowDelivery}
            disabled={disable}
          >
            Allow Delivery
          </Checkbox>
        </Col>
      </Row>
      <Divider />
      <Row>
        <Col span={24} style={{ marginBottom: 10 }}>
          <Typography style={{ fontSize: 20, fontWeight: "bold" }}>
            Merchant Banner
          </Typography>
        </Col>
        <Col span={24}>
          <Checkbox
            onChange={(e) => onChange(e, "allow-banner")}
            checked={allowBanner}
            disabled={disable}
          >
            Allow add/modify banner
          </Checkbox>
        </Col>
      </Row>
      <Divider />
      <Row>
        <Col span={24} style={{ marginBottom: 10 }}>
          <Typography style={{ fontSize: 20, fontWeight: "bold" }}>
            Dine Setup
          </Typography>
        </Col>
        <Col span={24}>
          <Checkbox
            onChange={(e) => onChange(e, "allow-dine-setup")}
            checked={allowDineSetup}
            disabled={disable}
          >
            Allow add/modify dine setup
          </Checkbox>
        </Col>
      </Row>
      <Divider />
      <Row>
        <Col span={24} style={{ marginBottom: 10 }}>
          <Typography style={{ fontSize: 20, fontWeight: "bold" }}>
            Additional Service
          </Typography>
        </Col>
        <Col span={24}>
          <Checkbox
            onChange={(e) => onChange(e, "allow-additional-services")}
            checked={allowAdditionalServices}
            disabled={disable}
          >
            Allow add/modify/paylater and checkout later
          </Checkbox>
        </Col>
      </Row>
      <Divider />
      <Row>
        <Col span={24} style={{ marginBottom: 10 }}>
          <Typography style={{ fontSize: 20, fontWeight: "bold" }}>
            Dine Pay Later
          </Typography>
        </Col>
        <Col span={24}>
          <Checkbox
            onChange={(e) => onChange(e, "allow-dine-paylater")}
            checked={allowDinePayLater}
            disabled={disable}
          >
            Allow dine pay later and checkout later without using additional
            services
          </Checkbox>
        </Col>
      </Row>
      <Divider />
      <Row>
        <Col span={24} style={{ marginBottom: 10 }}>
          <Typography style={{ fontSize: 20, fontWeight: "bold" }}>
            Production Station
          </Typography>
        </Col>
        <Col span={24}>
          <Checkbox
            onChange={(e) => onChange(e, "allow-sub-category")}
            checked={allowSubCategory}
            disabled={disable}
          >
            Allow add/modify production station
          </Checkbox>
        </Col>
      </Row>
      <Divider />
      <Row>
        <Col span={24} style={{ marginBottom: 10 }}>
          <Typography style={{ fontSize: 20, fontWeight: "bold" }}>
            Products
          </Typography>
        </Col>
        <Col span={24}>
          <Checkbox
            onChange={(e) => onChange(e, "allow-product-variant")}
            checked={allowVariant}
            disabled={disable}
          >
            Allow variants for specific product
          </Checkbox>
        </Col>
        <Col span={24}>
          <Checkbox
            onChange={(e) => onChange(e, "allow-product-per-kilo")}
            checked={allowPerKilo}
            disabled={disable}
          >
            Allow per kilo for specific product
          </Checkbox>
        </Col>
      </Row>
      <Divider />
      <Row>
        <Col span={24} style={{ marginBottom: 10 }}>
          <Typography style={{ fontSize: 20, fontWeight: "bold" }}>
            House Keeping Function
          </Typography>
        </Col>
        <Col span={24}>
          <Checkbox
            onChange={(e) => onChange(e, "allow-house-keeping")}
            checked={allowHouseKeeping}
            disabled={disable}
          >
            Allow merchant to have house keeping function
          </Checkbox>
        </Col>
      </Row>
      <Divider />

      <Row>
        <Col span={24} style={{ marginBottom: 10 }}>
          <Typography style={{ fontSize: 20, fontWeight: "bold" }}>
            Food Panda | Grab
          </Typography>
        </Col>
        <Col span={24}>
          <Checkbox
            onChange={(e) => onChange(e, "allow-punching-transaction")}
            checked={allowPunchingTransaction}
            disabled={disable}
          >
            Allow punch transaction for food panda / grab.
          </Checkbox>
        </Col>
      </Row>
      <Divider />
      <Row>
        <Col span={24} style={{ marginBottom: 10 }}>
          <Typography style={{ fontSize: 20, fontWeight: "bold" }}>
            Timein | Timeout
          </Typography>
        </Col>
        <Col span={24}>
          <Checkbox
            onChange={(e) => onChange(e, "allow-store-attendance")}
            checked={allowStoreAttendance}
            disabled={disable}
          >
            Allow store to use time in / time out using RFID.
          </Checkbox>
        </Col>
      </Row>
      <Divider />
      <Row>
        <Col span={24} style={{ marginBottom: 10 }}>
          <Typography style={{ fontSize: 20, fontWeight: "bold" }}>
            Multiple Cashier
          </Typography>
        </Col>
        <Col span={24}>
          <Checkbox
            onChange={(e) => onChange(e, "allow-multiple-cashier")}
            checked={allowMultipleCashier}
            disabled={disable}
          >
            Allow multiple cashier in 1 store
          </Checkbox>
        </Col>
      </Row>
    </Drawer>
  );
};

export default MerchantConfig;
